export default __webpack_public_path__ + "static/media/udemyReact2.3c5b9fba.png";